import axios from 'axios'

// Session invalidée par l'engine (reset de la double authentification par un admin) : retour au login
const SESSION_REVOKED = 'dash.error.session_revoked'
let redirecting = false

function logoutRevoked() {
  if (redirecting) return
  redirecting = true
  try {
    if (window.$crisp) window.$crisp.push(['do', 'session:reset'])
  } catch (e) {}
  localStorage.clear()
  localStorage.setItem('session_revoked', '1')
  location.href = '/'
}

const isRevoked = (status, body) => status === 401 && body && body.error === SESSION_REVOKED

export default {
  install(Vue) {
    Vue.http.interceptors.push((request, next) => {
      next(response => {
        if (isRevoked(response.status, response.body)) logoutRevoked()
      })
    })
    axios.interceptors.response.use(
      response => response,
      error => {
        const res = error && error.response
        if (res && isRevoked(res.status, res.data)) logoutRevoked()
        return Promise.reject(error)
      }
    )
  }
}
